export default "__VITE_ASSET__BnEI6T96__"